/* @flow */

import React from 'react';
import formStyles from '../styles/FormGeneral.scss';

type ComponentProps = {|
    child: Element,
|};

export const LastElement = ({ child }: ComponentProps) => {
    return <div className={formStyles.lastElement}>{child}</div>;
};
